<template>
    <div>
        <!-- Modal de Lançamentos -->
        <div class="modal fade" id="lancamentosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-dialog-total" role="document">
                <div class="modal-content modal-content-total" v-if="parms">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Consulta de {{ parms.origem == 'L' ? 'Lançamentos' : 'Baixas' }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <lancamento :parms="parms" ref="lancs" v-if="parms && parms.origem == 'L'" :block_redir="true" :view="true" :fluxo="true" />
                        <extrato-de-contas ref="baixas" :block_redir="true" :fluxo="true" :view="!is_financeiro" v-else />
                    </div>
                    <div class="modal-footer" v-if="false">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import Lancamento from './Lancamento.vue';
import ExtratoDeContas from './ExtratoDeContas.vue';

export default {
    data() { 
        return { 
            parms: { 
                origem: 'L', 
            },
        };
    },

    components: { 
        Lancamento, 
        ExtratoDeContas
    }, 

    computed: { 
        is_financeiro: function () { 
            return this.$route.path.slice(0,11) == '/financeiro';
        }
    },

    methods: {
        abrir(parms) { 
            if ( parms ) { 
                this.parms = null;

                this.$nextTick(() => { 
                    this.parms = parms; 

                    this.$nextTick(() => { 
                        if ( parms.origem == 'L' ) { 
                            this.$refs.lancs.preencher_parms(parms);

                            this.$nextTick(() => { 
                                this.$refs.lancs.load();
                            });
                        } else { 
                            this.$refs.baixas.preencher_parms(parms);

                            this.$nextTick(() => { 
                                this.$refs.baixas.load();
                            });
                        }
                    });
                });
            
                $('#lancamentosModal').modal('show');
            }
        }
    },
}
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}
</style>